/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { PalAuthSubmissionStatus } from './PalAuthSubmissionStatus';
import {
    PalAuthSubmissionStatusFromJSON,
    PalAuthSubmissionStatusFromJSONTyped,
    PalAuthSubmissionStatusToJSON,
    PalAuthSubmissionStatusToJSONTyped,
} from './PalAuthSubmissionStatus';

/**
 * 
 * @export
 * @interface PalReauthCreationLinkedPreAuth
 */
export interface PalReauthCreationLinkedPreAuth {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    status: PalAuthSubmissionStatus;
    /**
     * 
     */
    submitted_at: Date | null;
}



/**
 * Check if a given object implements the PalReauthCreationLinkedPreAuth interface.
 */
export function instanceOfPalReauthCreationLinkedPreAuth(value: object): value is PalReauthCreationLinkedPreAuth {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('submitted_at' in value) || value['submitted_at'] === undefined) return false;
    return true;
}

export function PalReauthCreationLinkedPreAuthFromJSON(json: any): PalReauthCreationLinkedPreAuth {
    return PalReauthCreationLinkedPreAuthFromJSONTyped(json, false);
}

export function PalReauthCreationLinkedPreAuthFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthCreationLinkedPreAuth {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'status': PalAuthSubmissionStatusFromJSON(json['status']),
        'submitted_at': (json['submitted_at'] == null ? null : parseDateTime(json['submitted_at'])),
    };
}

export function PalReauthCreationLinkedPreAuthToJSON(json: any): PalReauthCreationLinkedPreAuth {
    return PalReauthCreationLinkedPreAuthToJSONTyped(json, false);
}

export function PalReauthCreationLinkedPreAuthToJSONTyped(value?: PalReauthCreationLinkedPreAuth | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'status': PalAuthSubmissionStatusToJSON(value['status']),
        'submitted_at': value['submitted_at'] == null ? value['submitted_at'] : serializeDateTime(value['submitted_at']),
    };
}

